import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import countries from '../../../../../../assets/json/countries.json';

@Component({
  selector: 'app-add-award-winner',
  templateUrl: './add-award-winner.component.html',
  styleUrls: ['./add-award-winner.component.css']
})
export class AddAwardWinnerComponent implements OnInit {

  awardWinnerForm: FormGroup;
  id: number;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  isSubmitted = true;
  countryId: number;
  countryName: string;
  errorMessage: string = '';
  maxDate: Date;
  minDate: Date;
  years = [];
  onChangeValue = '';
  countries: any = [];
  awards = [];
  winners = [];
  banners = [];
  countryList: { name: string, id: string }[] = countries;
  domElement: string = 'view';
  selectedWinner: any = {};
  items = [];
  pageOfItems: Array<any>;

  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    public datePipe: DatePipe,
    private toastrService: ToastrService,

  ) {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 52850);
    this.maxDate.setDate(this.maxDate.getDate() - 2920);
    this.years = Array(20).fill(0).map((x, i) => ({ name: (i + 2019) }));
  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.getAllAwardWinners();

    this.awardWinnerForm = this.formBuilder.group({
      bannerId: ['', Validators.required],
      award: [Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      winnerCountry: ['', Validators.required],
      dob: ['', Validators.required],
      yearOfAward: ['', Validators.required],
      winnerAvatar: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],
    });
  }
  onclick(add: string) {

    if (add === 'add') {
      this.domElement = add;
      this.getAllBanners();
    } else if (add === 'view') {
      this.domElement = add;
    }
  }
  onChangePage(pageOfItems: Array<any>) {

    this.pageOfItems = pageOfItems;
  }
  getAllAwardWinners() {
    this.isLoaderVisible = true;
    this.iffhsService.getAllAwardWinners().subscribe((res: any) => {
      this.winners = res.winners;
      this.items = this.winners;
      this.isLoaderVisible = false;

    });
  }
  onChangeBanner(e) {
    this.onChangeValue = e.target.value || 0;

    this.getAwardsByBanner();
  }
  getAwardsByBanner() {
    this.isLoaderVisible = true;
    const data = {
      bannerId: this.onChangeValue,
    };
    this.iffhsService.getBannerAwards(data).subscribe((res: any) => {
      this.awards = res.awards;
      this.isLoaderVisible = false;
    });
  }
  getAllBanners() {
    this.isLoaderVisible = true;
    this.iffhsService.getAllBanners().subscribe((res: any) => {
      this.banners = res.banners;
      this.isLoaderVisible = false;
    });
  }
  onFileSelect(event) {
    const winnerAvatar = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.awardWinnerForm.get('winnerAvatar').setValue(winnerAvatar);

  }
  openDeleteModal(modal: any, award: any) {
    this.selectedWinner = award;
    modal.show();
  }
  deleteWinner(modal: any) {
    this.isLoaderVisible = true;
    const data = {
      winnerId: this.selectedWinner.id,
    };
    this.iffhsService.deleteWinner(data).subscribe(
      res => {
        modal.hide();
        this.isLoaderVisible = false;
        this.getAllAwardWinners();
        this.toastrService.success('Winner  Deleted', 'Message!');
      },
      error => {
        console.log(error);
      }
    );
  }
  onChange(e) {
    this.onChangeValue = e.target.value || 0;

  }
  get f() { return this.awardWinnerForm.controls; }
  addAwardWinner() {
    this.submitted = true;
    if (this.awardWinnerForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const dob = this.datePipe.transform(this.f.dob.value, 'yyyy-MM-dd');
    const fd = new FormData();
    fd.append('bannerId', this.awardWinnerForm.get('bannerId').value);
    fd.append('award', this.awardWinnerForm.get('award').value);
    fd.append('firstName', this.awardWinnerForm.get('firstName').value);
    fd.append('lastName', this.awardWinnerForm.get('lastName').value);
    fd.append('winnerCountry', this.awardWinnerForm.get('winnerCountry').value);
    fd.append('dob', dob);
    fd.append('yearOfAward', this.awardWinnerForm.get('yearOfAward').value);
    fd.append('winnerAvatar', this.awardWinnerForm.get('winnerAvatar').value);
    fd.append('createdBy', this.awardWinnerForm.get('createdBy').value);
    this.iffhsService.addAwardWinner(fd).pipe(first()).subscribe(
      data => {
        this.getAllAwardWinners();
        this.isLoaderVisible = false;
        this.toastrService.success('Winner Added!', 'Message!');
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');
      }
    );
    this.resetForm();
  }
  resetForm() {
    this.awardWinnerForm = this.formBuilder.group({
      bannerId: [''],
      award: [''],
      firstName: [''],
      lastName: [''],
      winnerCountry: [''],
      dob: [''],
      yearOfAward: [''],
      winnerAvatar: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }

}
